/**
 * MusicGeneratorFooterLink — the homepage footer's link to the song
 * generator, named "Free AI music generator" in the page's language
 * (shared/musicGeneratorLink.ts). Rendered in LandingV2's footer; the
 * homepage crawler HTML carries the same link (renderHomepageFooterLink in
 * server/_core/seo.ts). A real <a href> that navigates client-side on a
 * plain click.
 */
import type { MouseEvent } from "react";
import { useLanguageRouter } from "@/hooks/useLanguageRouter";
import {
  MUSIC_GENERATOR_PATH,
  musicGeneratorLinkLabel,
} from "@shared/musicGeneratorLink";

export default function MusicGeneratorFooterLink() {
  const { currentLang, withLanguagePath, navigate } = useLanguageRouter();

  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
      return;
    }
    e.preventDefault();
    navigate(MUSIC_GENERATOR_PATH);
  };

  return (
    <a href={withLanguagePath(MUSIC_GENERATOR_PATH)} onClick={onClick}>
      {musicGeneratorLinkLabel(currentLang)}
    </a>
  );
}
